// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__V9ZPH","logo":"Footer_logo__9j-sF","menu_list":"Footer_menu_list__-q1xW","privacy_area":"Footer_privacy_area__LrU-i"};